import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Fallback bearer token (kept in memory/localStorage) for environments where
// third-party cookies are restricted.
export function setToken(token) {
  if (token) localStorage.setItem("cvpcm_token", token);
  else localStorage.removeItem("cvpcm_token");
}

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("cvpcm_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export default api;
